import {Component, OnDestroy, OnInit} from '@angular/core';
import {CarouselResponsiveOptions} from 'primeng/carousel';
import {ViewportService} from '../../../services/viewport.service';
import {Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';

@Component({
    selector: 'how-it-works',
    templateUrl: './how-it-works.component.html',
    styleUrls: ['./how-it-works.component.scss']
})
export class HowItWorksComponent implements OnInit, OnDestroy {
    partnerId: string;
    numVisible: number;
    private destroy$ = new Subject<void>();

    steps = [
        { image: 'assets/images/how-it-works/HowItWorks1-400.webp', title: '1. Select your home airports', description: "Choose your favorite local international airports you'd like us to monitor for you." },
        { image: 'assets/images/how-it-works/HowItWorks2-400.webp', title: '2. Select dream destinations', description: "We'll search for deals to your dream destinations, plus surprise locations." },
        { image: 'assets/images/how-it-works/HowItWorks3-400.webp', title: '3. Get cheap flight alerts', description: "We'll send email & SMS alerts when we find flights up to 90% off leaving your selected airport." }
    ];

    responsiveOptions: CarouselResponsiveOptions[] = [
        { breakpoint: '1024px', numVisible: 3, numScroll: 1 },
        { breakpoint: '949px', numVisible: 2, numScroll: 1 },
        { breakpoint: '768px', numVisible: 1.3, numScroll: 1 },
        { breakpoint: '480px', numVisible: 1, numScroll: 1 },
        { breakpoint: '320px', numVisible: 1, numScroll: 1 }
    ];

    constructor(public viewport: ViewportService) {}

    ngOnInit(): void {
        this.updateNumVisible(this.viewport.dimensions.width);
        this.viewport.dimensions$.pipe(
            takeUntil(this.destroy$)
        ).subscribe(dimensions => {
            this.updateNumVisible(dimensions.width);
        });
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    updateNumVisible(screenWidth: number) {
        if (screenWidth < 768) {
            this.numVisible = 1;
        } else if (screenWidth < 992) {
            this.numVisible = 2;
        } else if (screenWidth < 1200) {
            this.numVisible = 3;
        } else if (screenWidth < 1400) {
            this.numVisible = 4;
        } else {
            this.numVisible = 5;
        }
    }


}
